<template>
  <div>
    <About v-if="pageName === 'About'" />
    <Careers v-if="pageName === 'Careers'" />
    <Documents v-if="pageName === 'Documents'" />
  </div>
</template>

<script>
  import About from './pages/about.vue';
  import Careers from './pages/careers.vue';
  import Documents from './pages/documents.vue';

  export default {
    name: 'container',

    components: {
      About,
      Careers,
      Documents,
    },

    data() {
      return {
        pageName: this.$root.pageName,
      };
    },
  };
</script>